import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://stlpazizqtsxdivkdnyk.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN0bHBheml6cXRzeGRpdmtkbnlrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzM0OTIwNzYsImV4cCI6MjA0OTA2ODA3Nn0.HGihUWPVHnAlb3Ye1OvmUapUrWuPtDKF1FIu5CyeQbI';

export const supabase = createClient(supabaseUrl, supabaseKey); 